// Whether the graph editors reveal a plugin's ADVANCED nodes. A per-browser preference.
// Notes: ~/comments/aos-threejs-poc/graphAdvancedMode_preference_not_server_data.md

const STORAGE_KEY = 'aos-graph-advanced-ogs'

const listeners = new Set()

function read() {
  if (typeof window === 'undefined') return false
  try { return window.localStorage.getItem(STORAGE_KEY) === 'true' } catch { return false }
}

let enabled = read()

/** Module singleton, not React state: the palette is rebuilt per render and reads it. */
export const graphAdvancedMode = {
  get enabled() { return enabled },
}

export function isGraphAdvancedMode() { return enabled }

/** Returns an unsubscribe. The editor re-renders its palette on a change. */
export function subscribeGraphAdvancedMode(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function setGraphAdvancedMode(on) {
  const next = !!on
  if (next === enabled) return enabled
  enabled = next
  if (typeof window !== 'undefined') {
    try { window.localStorage.setItem(STORAGE_KEY, next ? 'true' : 'false') } catch { /* private window */ }
  }
  for (const fn of listeners) {
    try { fn(next) } catch (e) { console.error('[graphAdvancedMode] listener threw', e) }
  }
  return enabled
}

export function toggleGraphAdvancedMode() { return setGraphAdvancedMode(!enabled) }

/** Test seam: forget the preference and every listener. */
export function resetGraphAdvancedMode() {
  enabled = false
  listeners.clear()
  if (typeof window === 'undefined') return
  try { window.localStorage.removeItem(STORAGE_KEY) } catch { /* private window */ }
}

/**
 * The palette entries a user may place right now.
 *
 * A manifest marked `advanced` is an authoring tool for a node that already has
 * a composite owner — placing one at top level does nothing — so it is offered
 * only in advanced mode. Pure, so the rule is unit-tested without the editor.
 */
export function visiblePaletteEntries(entries, advanced = enabled) {
  if (advanced) return entries
  return entries.filter((entry) => entry?._manifest?.advanced !== true)
}
